import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";

// "(source: deck.pdf)" and "— to confirm" read as small notes after a line, the way the design shows a
// claim's source; the text itself is unchanged.
const NOTE = /\(source:[^)]*\)|— to confirm/g;
const NOTE_CLASS = "ms-1 typo-caption whitespace-nowrap text-muted-foreground";

const editingKey = new PluginKey<boolean>("caseFrameEditing");

export const CaseFrameEditorMarks = Extension.create({
  name: "caseFrameEditorMarks",
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("caseFrameNotes"),
        props: {
          decorations(state) {
            const decorations: Decoration[] = [];
            state.doc.descendants((node, pos) => {
              if (!node.isTextblock) return true;
              for (const match of node.textContent.matchAll(NOTE)) {
                const from = pos + 1 + (match.index ?? 0);
                decorations.push(Decoration.inline(from, from + match[0].length, { class: NOTE_CLASS }));
              }
              return false;
            });
            return DecorationSet.create(state.doc, decorations);
          }
        }
      }),
      // The line being edited is marked, like the design's claim while it is edited.
      new Plugin({
        key: editingKey,
        state: {
          init: () => false,
          apply: (tr, focused: boolean) => (tr.getMeta(editingKey) as boolean | undefined) ?? focused
        },
        props: {
          handleDOMEvents: {
            focus: (view) => {
              view.dispatch(view.state.tr.setMeta(editingKey, true));
              return false;
            },
            blur: (view) => {
              view.dispatch(view.state.tr.setMeta(editingKey, false));
              return false;
            }
          },
          decorations(state) {
            if (!editingKey.getState(state)) return null;
            const { $head } = state.selection;
            for (let depth = $head.depth; depth >= 1; depth--) {
              if (depth === 1 || $head.node(depth).type.name === "listItem") {
                return DecorationSet.create(state.doc, [
                  Decoration.node($head.before(depth), $head.after(depth), { class: "is-editing" })
                ]);
              }
            }
            return null;
          }
        }
      })
    ];
  }
});
